import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationHelperService {
  public reconfirmationConfig = signal<
    { redirectUrl: string; reconfirmationType: ReconfirmationType } | undefined
  >(undefined);

  public setReconfirmationConfig(config: { redirectUrl: string; reconfirmationType: ReconfirmationType }) {
    this.reconfirmationConfig.set(config);
  }

  public clearReconfirmationConfig() {
    this.reconfirmationConfig.set(undefined);
  }
}

export type ReconfirmationType = 'email' | 'phone' | 'cop' | 'password';
